import { createSlice } from '@reduxjs/toolkit'
import translations from '../../database/translation.json'
import translationsMicrosite from '../../database/translation-microsite.json'
import { processRawTranslation } from '../../utils'

const translationSlice = createSlice({
  name: 'translation',
  initialState: {
    data: processRawTranslation(translations),
    data_microsite: processRawTranslation(translationsMicrosite)
  }
})

export default translationSlice.reducer
